<template lang="pug">
#claim_settlement
  custom-header(
    :title="claimSettlement.area01_Title",
    :subTitle="claimSettlement.area01_SubTitle",
    :image="claimSettlement.area01_Image",
    :buttonName="claimSettlement.area01_ButtonName",
    :buttonURL="claimSettlement.area01_ButtonURL"
  )

  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_8 {{ claimSettlement.area02_Title }}
    nav.top_tab.d-flex.flex-wrap.flex-md-nowrap.justify-content-start.justify-content-md-center.i_ml_per_sm_1
      nav-tab(
        v-for="(claimSettlementTab, index) in claimSettlement.area02_Introduce",
        :title="claimSettlementTab.ProductCategoryName",
        :key="index",
        :selected="selectedLink == index",
        @click.native="changeTab(index)"
      )
    .timeline.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center
      timeline-item.flex-grow-1(
        v-for="(timelineItem, index) in claimSettlementIntroduce.area02_StepList",
        :key="index",
        :title="timelineItem.area02_StepList_Title",
        :icon="timelineItem.area02_StepList_icon",
        :content="timelineItem.area02_StepList_Content"
      )

  section.container(
    v-if="claimSettlementIntroduce.area02_DetailStepStatus == 1"
  )
    .row.text-center.i_mt_8
      .collapse_btn(
        @click="isCollapseExpand = !isCollapseExpand",
        :class="{ expand: isCollapseExpand }"
      ) {{ isCollapseExpand ? collapseText[1] : collapseText[0] }}
    .step_line.fade.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center(
      v-if="isCollapseExpand"
    )
      step-line-item.flex-grow-1(
        v-for="(stepLineItem, index) in claimSettlementIntroduce.area02_DetailStepList",
        :key="index",
        :title="stepLineItem.area02_DetailStepList_Title",
        :icon="stepLineItem.area02_DetailStepList_icon"
      )

  section.container.position-relative
    h2.long_text.text-center.i_mt_10.i_mb_8 選擇投保商品，進一步了解特定商品的理賠流程、理賠文件、理賠相關問題
    .row.d-none.d-md-flex
      .col-3.i_mt_8.i_mt_md_4(
        v-for="(productQuestion, index) in claimSettlementIntroduce.area02_ProductList",
        :key="index"
      )
        border-tab(:productQuestion="productQuestion")
    .row.d-md-none.flex-nowrap.align-items-center.justify-content-center.position-relative.i_m_sm_0
      svg-icon.swiper-prev.d-md-none(
        iconClass="arrow_left_mobile",
        className="icon",
        @click="prevClick"
      )

      swiper.swiper-container.i_mlr_2(:options="swiperOption", ref="mySwiper")
        swiper-slide.swiper-slide(
          v-for="(productQuestion, index) in claimSettlementIntroduce.area02_ProductList",
          :key="index"
        )
          border-tab(:productQuestion="productQuestion")

      svg-icon.swiper-next.d-md-none(
        iconClass="arrow_right_mobile",
        className="icon",
        @click="nextClick"
      )

  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
    p.i_body_l.text-center(v-if="false") 也歡迎至「
      span
        router-link(
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }",
          style="cursor: pointer; color: #009ce5"
        ) 聯絡我們
      | 」留下問題，將有專人主動聯繫回覆您
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4(
        v-for="question in claimSettlementIntroduceQuestion"
      )
        question(:question="question")
    .row.text-center
      router-link.see_more_btn.sm.btn_yellow.text-center.i_mtb_10(
        tag="a",
        :to="{ name: 'CustomerServiceFAQ' }"
      ) 看更多
  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getClaimSettlement } from "@/json/customer_service";
import { getFAQDetail } from "@/json/FAQ";
import NavTab from "@/components/customer_service/NavTab";
import TimelineItem from "@/components/customer_service/TimelineItem";
import StepLineItem from "@/components/customer_service/StepLineItem";
import BorderTab from "@/components/customer_service/BorderTab";
import Question from "@/components/common/Question";
import DedicatedLine from "@/components/customer_service/DedicatedLine";

export default {
  name: "CustomerServiceClaimSettlement",
  metaInfo() {
    return {
      title: this.claimSettlement.SEO_Title,
      meta: [
        { name: "description", content: this.claimSettlement.SEO_Description },
      ],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "nav-tab": NavTab,
    "timeline-item": TimelineItem,
    "step-line-item": StepLineItem,
    "border-tab": BorderTab,
    question: Question,
    "dedicated-line": DedicatedLine,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        direction: "horizontal",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
      },
      claimSettlement: {},
      claimSettlementIntroduce: {},
      claimSettlementIntroduceQuestion: [],
      FAQDetail: [],
      selectedLink: 0,
      isCollapseExpand: false,
      collapseText: ["詳細理賠資訊", "收起理賠資訊"],
    };
  },
  created() {
    this.getClaimSettlement();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    getClaimSettlement() {
      getClaimSettlement().then((response) => {
        this.claimSettlement = response.data;
        getFAQDetail().then((response) => {
          this.FAQDetail = response.data.FAQDeatilList;
          if (
            this.claimSettlement.area02_Introduce &&
            this.claimSettlement.area02_Introduce.length > 0
          ) {
            this.changeTab(0);
          }
        });
      });
    },
    changeTab(index) {
      this.selectedLink = index;
      this.claimSettlementIntroduce =
        this.claimSettlement.area02_Introduce[index];

      this.claimSettlementIntroduceQuestion = [];
      if (
        this.claimSettlementIntroduce.area04_FAQ01ID &&
        this.claimSettlementIntroduce.area04_FAQ01ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.claimSettlementIntroduce.area04_FAQ01ID == detail.FAQID) {
            this.claimSettlementIntroduceQuestion.push(detail);
            break;
          }
        }
      }

      if (
        this.claimSettlementIntroduce.area04_FAQ02ID &&
        this.claimSettlementIntroduce.area04_FAQ02ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.claimSettlementIntroduce.area04_FAQ02ID == detail.FAQID) {
            this.claimSettlementIntroduceQuestion.push(detail);
            break;
          }
        }
      }

      if (
        this.claimSettlementIntroduce.area04_FAQ03ID &&
        this.claimSettlementIntroduce.area04_FAQ03ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.claimSettlementIntroduce.area04_FAQ03ID == detail.FAQID) {
            this.claimSettlementIntroduceQuestion.push(detail);
            break;
          }
        }
      }

      if (
        this.claimSettlementIntroduce.area04_FAQ04ID &&
        this.claimSettlementIntroduce.area04_FAQ04ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.claimSettlementIntroduce.area04_FAQ04ID == detail.FAQID) {
            this.claimSettlementIntroduceQuestion.push(detail);
            break;
          }
        }
      }
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    toFAQ() {
      this.$router.push({ name: "CustomerServiceFAQ" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/timeline_stepline";
@import "@/assets/style/customer_service/claim_settlement";
</style>
